import { axiosInstance } from "apis/_axios";

export const getProfileApi = () => axiosInstance().get("/profile");
